import React from "react";

import { ArrowBack } from "@mui/icons-material";

import { BaseBadge } from "components/BaseBadge";

import { AddButton } from "../AddButton";
import { DeleteButton } from "../DeleteButton";
import { FilterButton } from "../FilterButton";
import {
  Container,
  LeftSide,
  RightSide,
  PageLabel,
  BackContainer,
} from "./styles";

export interface IPageHeader {
  id?: string;
  label: string;
  quantity?: number;
  background: "primary" | "secondary";
  addClick?: () => unknown;
  filterClick?: () => unknown;
  deleteClick?: () => unknown;
  backClick?: () => unknown;
  isFilter?: boolean;
  disabledDeleteButton?: boolean;
  disabledFilterButton?: boolean;
  height?: string;
  disabled?: boolean;
}

export const PageHeader: React.FC<IPageHeader> = ({
  id,
  label,
  quantity,
  background,
  addClick,
  filterClick,
  deleteClick,
  isFilter = false,
  disabledDeleteButton = false,
  disabledFilterButton = false,
  height = "80px",
  disabled,
  backClick,
}) => {
  return (
    <Container id={id} data-testId={id} background={background} height={height}>
      <LeftSide>
        {backClick && (
          <BackContainer onClick={() => backClick()}>
            <ArrowBack color="primary" />
          </BackContainer>
        )}
        <PageLabel>{label}</PageLabel>
        {quantity ? <BaseBadge color="primary" content={quantity} /> : null}
      </LeftSide>
      {addClick || filterClick || deleteClick ? (
        <RightSide>
          {addClick ? (
            <AddButton disabled={disabled} onClick={addClick} />
          ) : null}
          {filterClick ? (
            <FilterButton
              disabledFilterButton={disabledFilterButton}
              isFilter={isFilter}
              onClick={filterClick}
            />
          ) : null}
          {deleteClick ? (
            <DeleteButton
              disabled={disabledDeleteButton}
              onClick={deleteClick}
            />
          ) : null}
        </RightSide>
      ) : null}
    </Container>
  );
};

export default PageHeader;
